import { render, staticRenderFns } from "./ConfigDatabaseUsersTab.vue?vue&type=template&id=f4f71edc&scoped=true"
import script from "./ConfigDatabaseUsersTab.vue?vue&type=script&lang=js"
export * from "./ConfigDatabaseUsersTab.vue?vue&type=script&lang=js"
import style0 from "./ConfigDatabaseUsersTab.vue?vue&type=style&index=0&id=f4f71edc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f71edc",
  null
  
)

export default component.exports